<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Select Project
      </h1>
      <br>
      <p class="subheader-style">
        Select a project under you want to <br>check-in.
      </p>
      <v-btn
        fab
        color="#E6E6E6"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <div
        v-if="!isProjectsAvailable"
        class="empty-alert-div"
      >
        <v-card
          elevation="0"
          color="#E6E6E6"
          class="check-in-history"
        >
          <br>
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No projects found
          </p>
          <br>
          <br>
        </v-card>
      </div>
      <template v-for="(item, i) in organizationProjects">
        <v-col
          :key="i"
          cols="12"
          md="12"
        >
          <div
            class="select-list-style"
            @click="toProjectGatesList(item)"
          >
            {{ item.name }}
          </div>
        </v-col>
      </template>
      <center-spinner
        :loading="loading"
      />
    </div>
  </v-dialog>
</template>

<script>
  import spinner from '../../../components/SpinnerCentre.vue';
  export default {
    name: 'SelectProject',
    components: {
      'center-spinner': spinner,
    },
    data: () => ({
      loading: false,
      showModal: true,
    }),
    computed: {
      organizationProjects () {
        return this.$store.getters['projects/getOrganizationProjects'];
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      isProjectsAvailable () {
        if (this.organizationProjects.length > 0) {
          return true;
        }
        return false;
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      await this.getOrganizationProjects();
    },
    methods: {
      async getOrganizationProjects () {
        this.loading = true;
        const organizationId = this.selectedOrganization.organization.external_id;
        await this.$store.dispatch('projects/fetchOrganizationProjects', {
          organizationExtId: organizationId,
        }).catch(() => {
          this.loading = false;
        });
        this.loading = false;
      },
      toProjectGatesList (item) {
        this.loading = true;
        this.$store.dispatch('projects/selectedOrgProject', item);
        setTimeout(() => {
          this.$emit('project-selected');
          this.loading = false;
        }, 1000);
      },
    },
  };
</script>
